import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import bubbleViews from '../../assets/images/bubbleViews.svg';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {Image} from '../common/image';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleDescription} from '../common/infoBubbles/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const LensesWorkspaceInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();
  const onClose = () => context.closeInfoBubbles(OnboardingTipTypesEnum.LENSES_WORKSPACE);

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.LENSES_WORKSPACE}
      position="right"
      targetRef={targetRef}
      isInteractive
    >
      <InfoBubbleContent>
        <Image src={bubbleViews} width={324} height={196} />
        <InfoBubbleTitle shouldWrapTitle>
          <Trans id="infobubble-lenses-workspace-title">
            Bring your most important work together with views
          </Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-lenses-workspace-description">
            Create custom work queues based on inboxes, tags, and assignees you care about for quick access to
            your top priorities.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button
            onClick={onClose}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-lenses-workspace-cta">Got it</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
